import styled from "styled-components";
import Text from "./Text";

export const SectionTitle = styled(Text)`
  margin: 0;
  font-size: 48px;

  @media screen and (max-width: 650px) {
    font-size: 22px;
    
  }
`;

export const SectionSubTitle = styled(Text)`
  margin: 0;
  color: rgba(255, 255, 255, 0.1);
  font-size: 56px;

  @media screen and (max-width: 650px) {
    display: none;
  }
`;